var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-grade"},[_c('span',{staticClass:"c-grade__header"},[_vm._v("年级分布")]),_c('div',{staticClass:"c-grade__bgc"},[(!_vm.show)?_c('EmptyLearning'):_vm._e(),_c('div',{staticClass:"accurate-grade"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }